(function () {
  function initRecipesListing(root) {
    if (!root || root.dataset.recipesReady === 'true') return;
    root.dataset.recipesReady = 'true';

    var grid = root.querySelector('[data-recipes-grid]');
    var searchInput = root.querySelector('[data-recipes-search-input]');
    var searchForm = root.querySelector('[data-recipes-search]');
    var sortSelect = root.querySelector('[data-recipes-sort]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-recipe-card]'));
    var originalOrder = cards.slice();

    function applySearch() {
      var query = (searchInput && searchInput.value ? searchInput.value : '').trim().toLowerCase();
      cards.forEach(function (card) {
        var haystack = card.getAttribute('data-search') || card.getAttribute('data-title') || '';
        var match = !query || haystack.indexOf(query) !== -1;
        card.classList.toggle('is-hidden-by-search', !match);
      });
    }

    function applySort() {
      if (!sortSelect) return;
      var value = sortSelect.value;
      var sorted = cards.slice();

      if (value === 'recommended') {
        sorted = originalOrder.slice();
      } else if (value === 'title-asc' || value === 'title-desc') {
        sorted.sort(function (a, b) {
          var ta = a.getAttribute('data-title') || '';
          var tb = b.getAttribute('data-title') || '';
          if (ta < tb) return value === 'title-asc' ? -1 : 1;
          if (ta > tb) return value === 'title-asc' ? 1 : -1;
          return 0;
        });
      } else if (value === 'newest' || value === 'oldest') {
        sorted.sort(function (a, b) {
          var da = parseInt(a.getAttribute('data-date') || '0', 10);
          var db = parseInt(b.getAttribute('data-date') || '0', 10);
          return value === 'newest' ? db - da : da - db;
        });
      }

      sorted.forEach(function (card) {
        grid.appendChild(card);
      });
      cards = sorted;
    }

    if (searchInput) {
      searchInput.addEventListener('input', applySearch);
    }

    if (searchForm) {
      searchForm.addEventListener('submit', function (event) {
        var query = (searchInput && searchInput.value ? searchInput.value : '').trim();
        if (query) {
          event.preventDefault();
          applySearch();
        }
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', applySort);
    }

    // Close filter menus when clicking outside
    document.addEventListener('click', function (event) {
      var openFilters = root.querySelectorAll('.recipes-listing__filter[open]');
      openFilters.forEach(function (details) {
        if (!details.contains(event.target)) {
          details.removeAttribute('open');
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-recipes-listing]').forEach(initRecipesListing);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('[data-recipes-listing]')
      : null;
    if (section) initRecipesListing(section);
  });
})();
